<div class="box-effect-two  wow fadeInUp text-left feature-box-effect selected">
    <div class="icon-box">
        <div class="img-effect mb-4"><img src="images/home-8/900.png" alt="fancybox"></div>
        <h5 class="mb-2">Customized Invoices</h5>
        <p class="mb-0">It is a long established fact that a reader will be distracted.</p>
    </div>
</div>